import * as React from "react"
import { Fragment } from "react"
import { Box, Link } from "@mui/material"
import { PopoverSeeker, PopoverSeekerItem } from "@ui-seeker/core"
import {FORMAT_DATE_BACK, formatDate, getPreviousDate} from "@ui-seeker/utils"

import {DATE_PERIODS} from "@constants"
import {commonFiltersValue} from "@signals"
import {
    digitalShelfEvolutionFilters, digitalShelfSubmittedFilters,
    digitalShelfEvolutionChartCurrentPeriod
} from "../../../@signals";


export default function ScoreColumnPopover({ anchorEl, onClose, urlDetails, detailsLabel, dataRow, kpiName }) {

	return <PopoverSeeker anchorEl={anchorEl} onClose={onClose}>
        <Box sx={{ mb: 1 }}>
            { !!urlDetails && <Link href={urlDetails} target="_blank" sx={{ cursor: 'pointer' }}>
                <PopoverSeekerItem icon="chart-tree-map" label={detailsLabel} onClick={e => onClose()} />
            </Link>}

            <Fragment>
                <PopoverSeekerItem 
                    icon="chart-tree-map" 
                    label={'Show Evolution'} 
                    onClick={() => {
                        const endDate = digitalShelfSubmittedFilters.value.endDate
                        let startDate = formatDate(getPreviousDate({days: 6}, endDate), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

                        digitalShelfEvolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

                        const baseFilters = {
                            ...commonFiltersValue.peek(),
                            startDate: startDate,
                            endDate: endDate,
                            country: dataRow?.country ? [dataRow.country] : commonFiltersValue.peek().country,
                            retailer: dataRow?.siteID ? [dataRow.siteID] : commonFiltersValue.peek().retailer,
                            brand: dataRow?.brandID ? [dataRow.brandID] : commonFiltersValue.peek().brand,
                            evolutionKPI: kpiName
                        }

                        if (kpiName.toLowerCase().includes('organic')) {
                            baseFilters.sponsored = 0
                        } else if (kpiName.toLowerCase().includes('sponsored')) {
                            baseFilters.sponsored = 1
                        }

                        digitalShelfEvolutionFilters.value = baseFilters
                        onClose()
                    }} 
                />
            </Fragment>
        </Box>
	</PopoverSeeker>
}